// Match the sample-data calendar coverage
const MINIMUM_CALENDAR_RADIUS_WEEKS = 156;

export function generateCalendarWeeks({ moment, limitationPeriod = 0, referenceDate = moment() }) {
    const configuredRadius = Number(limitationPeriod);
    const radius = Math.max(
        Number.isFinite(configuredRadius) && configuredRadius > 0
            ? Math.ceil(configuredRadius) + 1
            : 0,
        MINIMUM_CALENDAR_RADIUS_WEEKS
    );
    const currentWeek = moment(referenceDate)
        .utc()
        .startOf('isoWeek');

    return Array.from({ length: radius * 2 + 1 }, (_, index) => {
        const startDate = currentWeek
            .clone()
            .subtract(radius, 'weeks')
            .add(index, 'weeks');
        const endDate = startDate.clone().endOf('isoWeek');
        const mappedWeekStartDate = startDate
            .clone()
            .subtract(1, 'year')
            .startOf('isoWeek');

        return {
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString(),
            mappedWeek: mappedWeekStartDate.isoWeek(),
            mappedWeekStartDate: mappedWeekStartDate.toISOString(),
            mappedYear: mappedWeekStartDate.isoWeekYear(),
            quarter: startDate.quarter(),
            weekOfYear: startDate.isoWeek(),
            year: startDate.isoWeekYear(),
        };
    });
}

export function resolveWeeklyMetricsDateRange({ moment, firstWeek, lastWeek, startDate, endDate }) {
    if (!firstWeek || !lastWeek) return null;

    // Include the previous calendar year when needed for previous-YTD comparisons.
    const previousYear = moment().year() - 1;
    let resolvedStartDate = startDate;
    if (
        !resolvedStartDate &&
        moment({ year: previousYear }).isBefore(moment(firstWeek.startDate))
    ) {
        resolvedStartDate = `${previousYear}-01-01`;
    }

    return {
        startDate: resolvedStartDate,
        endDate: endDate || lastWeek.endDate,
    };
}
